import { Controller } from '@hotwired/stimulus';
import { COLLECTION_SAVE_CLICK } from 'components/analytics/conversions/constants/actions';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';

export default class CollectionSaveButtonController extends Controller {
  static values = {
    isPro: Boolean,
    contentType: String,
  }

  trackClick(event) {
    sendTrackingEvent({
      element: event.target,
      data: {
        action: COLLECTION_SAVE_CLICK,
        label: this.isProValue ? 'Pro' : 'Free',
        content_type: `Content-${this.contentTypeValue}`,
      },
    });
  }
}
